import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'; 
export interface Comment {
  comment: string;
}
@Component({
  selector: 'app-edit-comment',
  templateUrl: './edit-comment.component.html',
  styleUrls: ['./edit-comment.component.scss']
})
export class EditCommentComponent implements OnInit {
  commentForm!: FormGroup;
  constructor(
    private dialogRef: MatDialogRef<EditCommentComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: Comment,

  ) { }

  ngOnInit(): void {
    this.commentForm = this.formBuilder.group({
      comment: [this.data?.comment]
    });
  }

  save() {
    this.dialogRef.close(this.commentForm.value);
  }

  close() {
    this.dialogRef.close();
  }

}
